module.exports = __webpack_public_path__ + "static/img/78-2.679d3e5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/78-2.jpg
// module id = Ty5R
// module chunks = 0